var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"2.1,0 0,2.1 30,32.1 0,62.1 2.1,64.2 34.2,32.1 "}));
}

ChevronRight.defaultProps = {"viewBox":"0 0 34.2 64.2","height":"1em","width":"0.53em"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
